import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@cotyorg/ccx-atoms/Button';
import Icon from '@cotyorg/ccx-atoms/Icon';

const generateTextClassNames = ({ textExtraClass }) => (
  classNames(
    'icon-button__text',
    {
      [textExtraClass]: textExtraClass,
    },
  )
);

// istanbul ignore next
const IconButton = ({
  children,
  style,
  theme,
  size,
  extraClass,
  onClick,
  iconExtraClass,
  textExtraClass,
  iconAfterText,
  iconSrc,
  title,
  iconDataTest,
  testAttribute,
  iconWidth,
  iconHeight,
  ariaProps,
}) => {
  const iconButtonCssClass = classNames('icon-button', {
    [`icon-button--${style}`]: style,
    [`${extraClass}`]: extraClass,
  });

  const iconProps = {
    iconSrc,
    size,
    iconExtraClass,
    dataTest: iconDataTest,
    width: iconWidth,
    height: iconHeight,
  };

  return (
    <Button
      testAttribute={testAttribute}
      onClick={onClick}
      theme={theme}
      extraClass={iconButtonCssClass}
      title={title}
      extraProps={ariaProps}
    >
      {iconSrc && !iconAfterText && <Icon {...iconProps} />}
      {children && <span className={generateTextClassNames({ textExtraClass })}>{children}</span>}
      {iconSrc && iconAfterText && <Icon {...iconProps} />}
    </Button>
  );
};

IconButton.propTypes = {
  children: PropTypes.node,
  style: PropTypes.string,
  theme: PropTypes.oneOf(['primary', 'secondary', 'clear', 'hollow']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  extraClass: PropTypes.string,
  onClick: PropTypes.func,
  iconExtraClass: PropTypes.string,
  textExtraClass: PropTypes.string,
  iconAfterText: PropTypes.bool,
  iconSrc: PropTypes.string.isRequired,
  title: PropTypes.string,
  iconDataTest: PropTypes.string,
  testAttribute: PropTypes.string,
  iconWidth: PropTypes.number,
  iconHeight: PropTypes.number,
  ariaProps: PropTypes.object,
};

export default IconButton;
